document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.nutrients-slider').forEach((element) => {
    element.querySelector('.nutrients-slider-holder').addEventListener('scroll', (e) => {
      const holder = e.target;
      const scrollIndicator = holder.parentNode.querySelector('.icons-scroll-indicator');
      const innerWidth =
        holder.querySelectorAll('.articles-teaser').length * holder.querySelector('.articles-teaser').offsetWidth +
        (holder.querySelectorAll('.articles-teaser').length - 1) * parseInt(getComputedStyle(holder).rowGap);
      if (innerWidth > holder.offsetWidth) {
        scrollIndicator.style.setProperty('--amountScrolled', holder.scrollLeft);
        scrollIndicator.style.setProperty('--outerWidth', holder.offsetWidth);
        scrollIndicator.style.setProperty('--innerWidth', innerWidth);
        scrollIndicator.classList.remove('opacity-0');
      } else {
        scrollIndicator.classList.add('opacity-0');
      }
      scrollIndicator.style.setProperty('--amountScrolled', holder.scrollLeft);
    });
    element.querySelector('.nutrients-slider-holder').dispatchEvent(new CustomEvent('scroll'));
  });
});
